import React from "react";
import { Container } from "react-bootstrap";
import AboutPageBanner from "../components/About/AboutPageBanner";
import AnimationSection from "../components/About/AnimationSection";
import Clients from "../components/About/Clients";
import OurTeam from "../components/About/OurTeam";
import TextAnimataion from "../components/About/TextAnimataion";
import ThreeDots from "../components/About/ThreeDots";

const About = () => {
  return (
    <Container fluid className="p-0">
      <ThreeDots />
      <AboutPageBanner />
      <AnimationSection />
      <TextAnimataion />
      <OurTeam />
      <Clients />
    </Container>
  );
};

export default About;
